import {
  Col,
  MainContentArea,
  PageContentWrapper,
  PageTitle,
  Row,
  DesignTokens,
  Button,
  Card,
  Text,
  FullWidthSpace,
} from "melco-ui";
import { FC } from "react";
import { useGenericDrawer } from "melco-shared-logic";
import { CreateLicenseDrawer } from "../../components/licensemanager/drawer/CreateLicenseDrawer";
import { UpgradeLicenseDrawer } from "../../components/licensemanager/drawer/UpgradeLicenseDrawer";
import { ChangeLevelLicenseDrawer } from "../../components/licensemanager/drawer/ChangeLevelLicenseDrawer";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { CreateMachineLicensesDrawer } from "../../components/licensemanager/drawer/CreateMachineLicensesDrawer";
import { ChangeMachineLicensesDrawer } from "../../components/licensemanager/drawer/ChangeMachineLicensesDrawer";

const { spacings } = DesignTokens;

/**
 *Just information Made ButtonTextWrapper as we need width for text 100px as per requirement in ticket MC-656
 */
const ButtonTextWrapper = styled.span`
  width: 100px;
`;

const InternalSection = styled.div`
  width: 100%;
  margin-bottom: 50px;
`;

const LicenseManager: FC = () => {
  const upgradeLicenseDrawer = useGenericDrawer();
  const createLicenseDrawer = useGenericDrawer();
  const changeLevelLicenseDrawer = useGenericDrawer();
  const createMachineLicensesDrawer = useGenericDrawer();
  const changeMachineLicensesDrawer = useGenericDrawer();

  const { t } = useTranslation();
  const { roles } = useRolesContext();

  const { openDrawer: openUpgradeLicenseDrawer } = upgradeLicenseDrawer;
  const { openDrawer: openCreateLicenseDrawer } = createLicenseDrawer;
  const { openDrawer: openChangeLevelLicenseDrawer } = changeLevelLicenseDrawer;

  const { openDrawer: openCreateMachineLicensesDrawer } =
    createMachineLicensesDrawer;
  const { openDrawer: openChangeMachineLicensesDrawer } =
    changeMachineLicensesDrawer;
  return (
    <>
      <MainContentArea>
        <PageContentWrapper>
          <InternalSection>
            {" "}
            <PageTitle>{t("main_menu.licensemanager")}</PageTitle>
            <Row gutter={[spacings.middle, spacings.middle]}>
              {roles.LICENSE_MANAGER_CREATE && (
                <Col xs={24} md={12}>
                  <Card title={t("licensemanager.cards.create.title")}>
                    <FullWidthSpace direction="vertical" size="small">
                      <Text>{t("licensemanager.cards.create.text")}</Text>
                      <Row justify="end">
                        <Col>
                          <Button
                            type="primary"
                            style={{ minWidth: "100px" }}
                            onClick={() => openCreateLicenseDrawer()}
                          >
                            <ButtonTextWrapper>
                              {t("licensemanager.cards.create.button")}
                            </ButtonTextWrapper>
                          </Button>
                        </Col>
                      </Row>
                    </FullWidthSpace>
                  </Card>
                </Col>
              )}

              {roles.LICENSE_MANAGER_UPGRADE && (
                <Col xs={24} md={12}>
                  <Card title={t("licensemanager.cards.upgrade.title")}>
                    <FullWidthSpace direction="vertical" size="small">
                      <Text>{t("licensemanager.cards.upgrade.text")}</Text>
                      <Row justify="end">
                        <Col>
                          {/* <ButtonWrapper> */}
                          <Button
                            type="primary"
                            style={{ minWidth: "100px" }}
                            onClick={() => openUpgradeLicenseDrawer()}
                          >
                            <ButtonTextWrapper>
                              {t("licensemanager.cards.upgrade.button")}
                            </ButtonTextWrapper>
                          </Button>
                          {/* </ButtonWrapper> */}
                        </Col>
                      </Row>
                    </FullWidthSpace>
                  </Card>
                </Col>
              )}

              {roles.LICENSE_MANAGER_UPDATE && (
                <Col xs={24} md={12}>
                  <Card title={t("licensemanager.cards.changelicense.title")}>
                    <FullWidthSpace direction="vertical" size="small">
                      <Text>
                        {t("licensemanager.cards.changelicense.text")}
                      </Text>
                      <Row justify="end">
                        <Col>
                          <Button
                            type="primary"
                            onClick={() => openChangeLevelLicenseDrawer()}
                            style={{ minWidth: "100px" }}
                          >
                            <ButtonTextWrapper>
                              {t("licensemanager.cards.changelicense.button")}
                            </ButtonTextWrapper>
                          </Button>
                        </Col>
                      </Row>
                    </FullWidthSpace>
                  </Card>
                </Col>
              )}
            </Row>
          </InternalSection>
          <InternalSection>
            <PageTitle>{t("main_menu.machinelicenses")}</PageTitle>
            <Row gutter={[spacings.middle, spacings.middle]}>
              {roles.LICENSE_MANAGER_MACHINE_CREATE && (
                <Col xs={24} md={12}>
                  <Card title={t("machinelicenses.cards.create.title")}>
                    <FullWidthSpace direction="vertical" size="small">
                      <Text>{t("machinelicenses.cards.create.text")}</Text>
                      <Row justify="end">
                        <Col>
                          <Button
                            type="primary"
                            style={{ minWidth: "100px" }}
                            onClick={() => openCreateMachineLicensesDrawer()}
                          >
                            <ButtonTextWrapper>
                              {t("machinelicenses.cards.create.button")}
                            </ButtonTextWrapper>
                          </Button>
                        </Col>
                      </Row>
                    </FullWidthSpace>
                  </Card>
                </Col>
              )}

              {roles.LICENSE_MANAGER_MACHINE_UPDATE && (
                <Col xs={24} md={12}>
                  <Card title={t("machinelicenses.cards.change.title")}>
                    <FullWidthSpace direction="vertical" size="small">
                      <Text>{t("machinelicenses.cards.change.text")}</Text>
                      <Row justify="end">
                        <Col>

                          <Button
                            //   disabled
                            type="primary"
                            style={{ minWidth: "100px" }}
                            onClick={() => openChangeMachineLicensesDrawer()}
                          >
                            <ButtonTextWrapper>
                              {t("machinelicenses.cards.change.button")}
                            </ButtonTextWrapper>
                          </Button>

                        </Col>
                      </Row>
                    </FullWidthSpace>
                  </Card>
                </Col>
              )}
            </Row>
          </InternalSection>
        </PageContentWrapper>
      </MainContentArea>
      <UpgradeLicenseDrawer drawer={upgradeLicenseDrawer} />
      <CreateLicenseDrawer drawer={createLicenseDrawer} />
      <ChangeLevelLicenseDrawer drawer={changeLevelLicenseDrawer} />
      <CreateMachineLicensesDrawer drawer={createMachineLicensesDrawer} />
      <ChangeMachineLicensesDrawer drawer={changeMachineLicensesDrawer} />

    </>
  );
};
export default LicenseManager;
